import { ITheme } from '.';

export function validateTheme(theme?: ITheme) {
	if (!theme) {
		throw new Error('No theme provider implement.');
	}

	return theme;
}
